import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var REACH_GOAL_TYPES = {
  ConvergentPhoneClick: 'ConvergentPhoneClick',
  HomeTariffPhoneClick: 'HomeTariffPhoneClick',
  ConvergentTariffConnect: 'ConvergentTariffConnect',
  HomeTariffConnect: 'HomeTariffConnect',
  HomeTariffCallbackForm: 'HomeTariffCallbackForm',
  ConvergentTariffCallbackShortForm: 'ConvergentTariffCallbackShortForm',
  HomeTariffCallbackLongForm: 'HomeTariffCallbackLongForm',
  ConvergentTariffCallbackLongFormNew: 'ConvergentTariffCallbackLongFormNew',
  FttbAddressConnectionIsNotPossibleNotInME: 'FttbAddressConnectionIsNotPossibleNotInME',
  FttbCheckAddressClickButtonCheckAddress: 'FttbCheckAddressClickButtonCheckAddress',
  FttbConstructorClickButtonOrderWithOutMastersSchedule: 'FttbConstructorClickButtonOrderWithOutMastersSchedule',
  FmcConstructorClickButtonOrderWithOutMastersSchedule: 'FmcConstructorClickButtonOrderWithOutMastersSchedule',
  FmcConstructorClickButtonsMastersDetails: 'FmcConstructorClickButtonsMastersDetails',
  FttbConstructorClickButtonsMastersDetails: 'FttbConstructorClickButtonsMastersDetails',
  FttbConstructorClickButtonOrderFromCheckBlock: 'FttbConstructorClickButtonOrderFromCheckBlock',
  FmcConstructorClickButtonOrderFromCheckBlock: 'FmcConstructorClickButtonOrderFromCheckBlock'
};
export var MAIN_FMC_SERVICE_CARDS_TYPE = {
  balance: 'FttbCheckAddressClickButtonTopup',
  elk: 'FttbCheckAddressClickButtonCallBack',
  support: 'FttbCheckAddressClickButtonHelp',
  mnp: 'FttbCheckAddressClickButtonRelocation'
};
export var ANALYTICS_USERS_TYPE = {
  FMC: 5,
  FTTB: 4,
  MOBILE: 3,
  NONE: 0
};
export var ANALYTICS_USERS_BY_TYPE = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ANALYTICS_USERS_TYPE.FMC, 'fmc'), ANALYTICS_USERS_TYPE.FTTB, 'fttb'), ANALYTICS_USERS_TYPE.MOBILE, 'mobile'), ANALYTICS_USERS_TYPE.NONE, 'none');
export var ANALYTICS_PAGE_TYPES = {
  fmc: 'fmc',
  fttb_net: 'fttb_net',
  fttb_kit: 'fttb_kit'
};
export var ANALYTICS_ACTION_TYPES = {
  view: 'view',
  click: 'click',
  fill_in: 'fill_in',
  start: 'start',
  timeover: 'timeover',
  swipe: 'swipe',
  upload: 'upload',
  confirm: 'confirm',
  icon: 'icon'
};
export var ANALYTICS_ITEM_TYPES = {
  banner: 'banner',
  stories: 'stories',
  screen: 'screen',
  link: 'link',
  button: 'button',
  icon: 'icon',
  checkbox: 'checkbox',
  tab: 'tab',
  radiobutton: 'radiobutton',
  element: 'element',
  toggle: 'toggle',
  field: 'field',
  selector: 'selector',
  selector_item: 'selector_item',
  upBar: 'upbar',
  tile: 'tile',
  story_slide: 'story_slide',
  widget: 'widget',
  spoiler: 'spoiler',
  notification: 'notification',
  push: 'push',
  message: 'message',
  search_hint: 'search_hint',
  page: 'page',
  popup: 'popup',
  block: 'block',
  marker: 'marker',
  list: 'list',
  calendar: 'calendar',
  rangeSlider: 'rangeslider'
};
export var ANALYTICS_ICON_TYPES = {
  delete: 'delete',
  detail: 'detail',
  edit: 'edit',
  close: 'close',
  export: 'export',
  back: 'back',
  play: 'play',
  pause: 'pause',
  add: 'add',
  filter: 'filter',
  plus: 'plus',
  minus: 'minus'
};
export var ANALYTICS_OBJECT_TYPES = {
  top: 'top',
  footer: 'footer',
  block: 'block',
  popup: 'popup',
  notification: 'notification',
  main_menu: 'main_menu',
  banner: 'banner',
  floating: 'floating',
  screen: 'screen'
};
export var ANALYTICS_FLOW_TYPES = {
  callback_order: 'callback_order'
};
export var PHONE_FIELD_NAME = 'Номер телефона';
export var POPUP_TITLE = 'Заявка на подключение';
export var CALLBACK_REQUEST_BUTTON_NAME = 'Заказать звонок';
export var FTTB_BLOCK_NAME = {
  check_address_without_map: 'Проверка адреса без карты',
  check_address_middleform: 'fttb_check_address_middleform'
};
export var ANALYTICS_ORDER_TYPES = {
  order: 'order',
  callback: 'callback'
};